import { Component, OnInit, HostListener } from '@angular/core';
import { slideLeftRightAnimation } from '@base-shared/animations';
import { HeaderService } from '@base/shared/services';
import { forEach } from 'lodash';

@Component({
  selector: 'eyrus-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.sass'],
  animations: [slideLeftRightAnimation],

})
export class SidePanelComponent implements OnInit {

  opened: Boolean = false;
  private subscriptions: any = {};

  constructor(
    private header: HeaderService
  ) { }

  ngOnInit() {
    this.subscriptions.sidePanelOpen = this.header.panelOpen
      .subscribe(() => this.opened = true);

    this.subscriptions.sidePanelClose = this.header.panelClose
      .subscribe(() => this.opened = false);
  }

  ngOnDestroy() {
    forEach(this.subscriptions, (value) => value.unsubscribe());
  }

  /**
   * Listen click event when panel is opened
   * if user clicks / touch in the backdrop
   * this will automatically be closed
   * @param event DOM Event
   */
  @HostListener('click', ['$event'])
  onClick(event: any) {
    const inBackdrop = event.target.getAttribute('id');
    if (inBackdrop === 'panel-backdrop')
      return this.close();
    return;
  }

  /**
 * Close side bar
 */
  close() {
    this.opened = false;
  }

}
